<template>
  <div class="banner">
    <app-svg
      :style="{ fill: $store.state.bannerdata.background_color }"
      class="banner__svg1"
    ></app-svg>
    <app-svg
      :style="{ fill: $store.state.bannerdata.background_color }"
      class="banner__svg2"
    ></app-svg>
    <!-- #CEFFAB -->

    <p :style="{ color: $store.state.bannerdata.text_color }" class="banner__p">
      {{ $store.state.bannerdata.text }}
    </p>
    <!-- <app-svg></app-svg> -->
  </div>
</template>

<script>
import svg from "./svgstar.vue";
export default {
  data() {
    return {
      list: []
    };
  },
  components: {
    appSvg: svg
  }
};
</script>

<style lang="scss">
.banner {
  position: fixed;
  top: 0;
  width: 100%;
  height: 70px;
  background: var(--main-color);
  //   margin-top: 5em;
  z-index: 98;
  display: flex;
  justify-content: center;
  align-items: center;

  &__svg1 {
    opacity: 0.3;
    position: absolute;
    left: 2%;
    width: 200px;
  }
  &__svg2 {
    opacity: 0.3;
    position: absolute;
    right: 3%;
    width: 200px;
    rotate: 200deg;
  }

  &__p {
    font-family: "lalezar";
    font-size: 22px;
    color: var(--shrink);
    position: relative;
    @media screen and (max-width: 1000px) {
      font-size: 0.9em;
    }
    @media screen and (max-width: 800px) {
      font-size: 0.7em;
    }
    @media screen and (max-width: 500px) {
      font-size: 0.5em;
    }
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      width: 80px;
      height: 2px;
      background: linear-gradient(
        90deg,
        rgba(255, 131, 131, 1) 33%,
        rgba(0, 8, 248, 0) 100%
      );
      //   transform: translate(50%, 0);
      // margin-left: 15em;
      left: -30%;
      opacity: 0.2;
      @media screen and (max-width: 800px) {
        width: 50px;
        left: -45%;
      }
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      width: 80px;
      height: 2px;
      background: linear-gradient(
        -90deg,
        rgba(235, 131, 131, 1) 33%,
        rgba(0, 0, 0, 0) 100%
      );
      // margin-right: 15em;
      right: -30%;
      opacity: 0.2;
      //   transform: translate(50%, 0);
      @media screen and (max-width: 800px) {
        right: -45%;
        width: 50px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/banner.vue